<div class="dialog-overlay">
    <div class="dialog-container">
        <div class="dialog-border">
            <div class="dialog-header">
                <div class="icon-container {{ iconContainerClass }}">
                    <i class="dialog-icon fas {{ iconClass }}"></i>
                </div>
            </div>
            <div class="dialog-content">
                <div class="dialog-content-header">
                    {{ title }}
                </div>
                <div class="dialog-content-message">
                    {{ message }}
                </div>
            </div>
            <div *ngIf="type.toLowerCase() != 'warning'" class="dialog-footer">
                <button class="{{ buttonClass }}" (click)="onConfirm()"> OK </button>
            </div>
            <div *ngIf="type.toLowerCase() == 'warning'"class="dialog-footer">
                <button class="button-cancel" (click)="onCancel()"> Cancel </button>
                <button class="button-confirm" (click)="onConfirm()"> Confirm </button>
            </div>
        </div>
    </div>
</div>